import { useEffect, useState } from "react";
import { Caption1 } from "@fluentui/react-components";
import { MingleEvent, subscribeToUpcomingEvents } from "../api/events";
import EventCard from "./EventCard";
import styles from "./EventCard.module.css";

export default function Events() {
  const [events, setEvents] = useState<MingleEvent[]>([]);
  // Distinguishes "still loading" from "genuinely nothing upcoming", so the
  // empty message doesn't flash before the first snapshot arrives.
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const unsubscribe = subscribeToUpcomingEvents((upcoming) => {
      setEvents(upcoming);
      setLoaded(true);
    });

    return unsubscribe;
  }, []);

  if (!loaded) return null;

  if (!events.length) {
    return (
      <div className={styles.empty}>
        <Caption1>
          No events on the calendar right now — sign up above and we'll let you
          know as soon as the next one is announced.
        </Caption1>
      </div>
    );
  }

  return (
    <div className={styles.main}>
      {events.map((event) => (
        <EventCard key={event.id} event={event} />
      ))}
    </div>
  );
}
